export const HEADER_RIGHT_CTA_CLICK = 'web_landing_page_cta_clicked'
export const LOGIN_POPUP_OPEN = 'web_landing_page_login_popup_viewed'
export const LOGIN_SIGNUP_CTA_CLICK = 'web_landing_page_login_popup_cta_clicked'
export const OTP_POPUP_OPEN = 'web_landing_page_otp_popup_viewed'
export const OTP_POPUP_CTA_CLICK = 'web_landing_page_otp_popup_cta_clicked'
export const LOGIN_SUCCESSFUL = 'web_landing_page_login_success'
export const LOGIN_FAILED = 'web_landing_page_login_error'
export const CREATE_ACCOUNT_PAGE_VIEWED = 'web_create_account_page_viewed'
export const CREATE_ACCOUNT_CTA_CLICK = 'web_create_account_cta_clicked'
